import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { IMapGeometryWicket } from "~app/common/components/map/map.settings";
import { TransportforetagSearchResultDTO } from "~app/common/models/kontakter/TransportforetagSearchResultDTO";
import { TransportomradeDTO } from "~app/common/models/kontakter/TransportomradeDTO";
import { MottagningsplatsMarkerDTO } from "~app/common/models/mottagningsplats/MottagningsplatsMarkerDTO";
import { TplTransportforetagDTO } from "~app/common/models/transport/TplTransportforetagDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ApiClientService } from "../../../../common/services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class TransportforetagService {
    private readonly apiClient = inject(ApiClientService);

    search(searchtext: string, active = false): Observable<TransportforetagSearchResultDTO[]> {
        return this.apiClient.get<TransportforetagSearchResultDTO[]>("transportforetag/search", false, {
            searchtext: searchtext,
            active: active
        });
    }

    get(id: number) {
        return this.apiClient.get<TplTransportforetagDTO>(`transportforetag/${id}`, false);
    }

    getOmraden(id: number) {
        return this.apiClient.get<TransportomradeDTO[]>(`transportforetag/${id}/omraden`, false);
    }

    getAllTransportforetag(reset = false): Observable<TplTransportforetagDTO[]> {
        return this.apiClient.getCached<TplTransportforetagDTO[]>(`transportforetag`, false, reset);
    }

    getAllTransportforetagWithGeometryExcept(id: any): Observable<TplTransportforetagDTO[]> {
        return this.getAllTransportforetag().pipe(
            map(result => result.filter(one => one.koordinater?.length > 0 && one.id.toString() !== id))
        );
    }

    getAllMottagningsplatsMarkers(): Observable<MottagningsplatsMarkerDTO[]> {
        return this.apiClient.getCached<MottagningsplatsMarkerDTO[]>("mottagningsplats/markers", false);
    }

    getTransportforetagColors(): Observable<string[]> {
        return this.apiClient.getCached<string[]>("transportforetag/colors", false);
    }

    getGeometriesForTransportforetag(transportforetag: TplTransportforetagDTO[], omradeFlaggor: number): IMapGeometryWicket[] {
        const result = [];
        transportforetag.forEach(foretag => {
            foretag.koordinater.forEach(koordinat => {
                // eslint-disable-next-line no-bitwise
                if ((omradeFlaggor & koordinat?.omradeFlaggor) === koordinat?.omradeFlaggor &&
                    !ObjectUtils.isNullOrUndefined(koordinat.centrumKoordinat)) {
                    result.push({
                        foretag: foretag,
                        geometri: koordinat.centrumKoordinat
                    });
                }
            });
        });
        return result.map(flat => (({
            id: flat.foretag.id,
            iconid: "truck",
            visible: true,
            wkt: flat.geometri,
            tag: flat.foretag,
            label: flat.foretag.namn
        })));
    }
}
